  <div class="teamMembers" #teamContainer>

    <div *ngFor="let member of team" class="avatarContainer">
      <span class="tooltiptext">{{member.displayName}}</span>

      <img *ngIf="member.status" class="imageStatus" src="assets/img/icons/icon_notAvailable.png">
      <img *ngIf="!(member.status)" class="avatar draggableteamwidget" 
          [src]="'data:image/png;base64,'+ member.avatarImage"
          [attr.data-member-id]="member.id" 
      >
    </div>
  </div>
  